import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

// Distinct from the empty state: an empty table here would assert "no vendor
// is missing recipients", which a failed fetch cannot know.
export function VendorsErrorState({ onRetry }: { onRetry: () => void }) {
    return (
        <div className="flex flex-1 items-center justify-center px-8 pb-8">
            <div className="flex flex-col items-center gap-3 max-w-md text-center bg-white border border-gray-200 rounded-xl shadow-sm p-8">
                <span className="w-10 h-10 rounded-full bg-red-50 flex items-center justify-center">
                    <ExclamationTriangleIcon className="h-5 w-5 text-red-600" />
                </span>
                <h2 className="text-lg font-bold text-gray-800">Couldn't load vendors</h2>
                <p className="text-sm text-gray-600">
                    This page reports which vendors cannot receive purchase orders. Until it loads,
                    treat the absence of warnings as unknown rather than as all-clear.
                </p>
                <button
                    type="button"
                    onClick={onRetry}
                    className="bg-white text-gray-800 border border-gray-300 px-4 py-2 rounded-lg hover:bg-gray-50 transition-colors font-semibold text-sm"
                >
                    Retry
                </button>
            </div>
        </div>
    );
}
